import React, { useState } from "react";

export default function DatasetQuiz() {
  const [selectedDataset, setSelectedDataset] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [userAnswers, setUserAnswers] = useState({});
  const [score, setScore] = useState(null);

  const datasets = {
    pets: {
        headers: ["Child", "Pet", "Color", "Age"],
        data: [
          ["Tom", "Dog", "Brown", "5"],
          ["Lily", "Cat", "White", "3"],
          ["Max", "Fish", "Gold", "1"],
          ["Sara", "Parrot", "Green", "2"],
          ["Ben", "Rabbit", "Gray", "4"]
        ],
        questions: [
          { q: "Who owns a Cat?", options: ["Tom", "Lily", "Sara", "Ben"], answer: "Lily" },
          { q: "Which pet is Gold?", options: ["Fish", "Dog", "Parrot", "Rabbit"], answer: "Fish" },
          { q: "Who is 5 years old?", options: ["Tom", "Lily", "Ben", "Sara"], answer: "Tom" },
          { q: "Which pet is Green?", options: ["Cat", "Fish", "Parrot", "Dog"], answer: "Parrot" },
          { q: "Who owns a Rabbit?", options: ["Tom", "Max", "Ben", "Sara"], answer: "Ben" },
          { q: "What color is the Cat?", options: ["White", "Brown", "Gray", "Gold"], answer: "White" },
          { q: "Who owns the youngest pet?", options: ["Tom", "Max", "Ben", "Lily"], answer: "Max" }
        ]
      },
      breakfast: {
        headers: ["Name", "Favorite Food", "Drink", "Time"],
        data: [
          ["Amy", "Pancakes", "Milk", "8:00 AM"],
          ["Leo", "Cereal", "Juice", "7:30 AM"],
          ["Ella", "Toast", "Tea", "8:15 AM"],
          ["Ryan", "Waffles", "Water", "7:45 AM"],
          ["Zoe", "Fruit", "Milk", "8:00 AM"]
        ],
        questions: [
          { q: "Who had Toast?", options: ["Amy", "Ella", "Ryan", "Leo"], answer: "Ella" },
          { q: "What time did Leo eat?", options: ["8:00 AM", "7:30 AM", "7:45 AM", "8:15 AM"], answer: "7:30 AM" },
          { q: "Who drank Water?", options: ["Zoe", "Ryan", "Amy", "Ella"], answer: "Ryan" },
          { q: "What did Amy eat?", options: ["Waffles", "Fruit", "Pancakes", "Cereal"], answer: "Pancakes" },
          { q: "Who ate Waffles?", options: ["Ella", "Leo", "Ryan", "Zoe"], answer: "Ryan" },
          { q: "Who had breakfast at 8:15 AM?", options: ["Amy", "Ella", "Zoe", "Leo"], answer: "Ella" },
          { q: "What did Zoe drink?", options: ["Milk", "Juice", "Tea", "Water"], answer: "Milk" }
        ]
      },
      classroom: {
        headers: ["Student", "Desk Color", "Bag Color", "Favorite Subject"],
        data: [
          ["John", "Blue", "Red", "Math"],
          ["Emma", "Green", "Pink", "English"],
          ["David", "Yellow", "Black", "Science"],
          ["Olivia", "Red", "Blue", "Art"],
          ["Ethan", "Purple", "Green", "Music"]
        ],
        questions: [
          { q: "Who has a Yellow desk?", options: ["Emma", "David", "John", "Ethan"], answer: "David" },
          { q: "What is Olivia's favorite subject?", options: ["Art", "Science", "Math", "Music"], answer: "Art" },
          { q: "Who has a Green desk?", options: ["Emma", "David", "Ethan", "John"], answer: "Emma" },
          { q: "Whose bag is Red?", options: ["John", "Emma", "David", "Ethan"], answer: "John" },
          { q: "Who loves Music?", options: ["Olivia", "Ethan", "Emma", "David"], answer: "Ethan" },
          { q: "Who has a Pink bag?", options: ["Emma", "John", "David", "Ethan"], answer: "Emma" },
          { q: "Whose desk is Purple?", options: ["Ethan", "John", "Emma", "Olivia"], answer: "Ethan" }
        ]
      },
      toys: {
        headers: ["Child", "Toy", "Color", "Size"],
        data: [
          ["Anna", "Ball", "Red", "Big"],
          ["Jake", "Car", "Blue", "Small"],
          ["Mia", "Doll", "Pink", "Medium"],
          ["Noah", "Blocks", "Yellow", "Big"],
          ["Liam", "Puzzle", "Green", "Small"]
        ],
        questions: [
          { q: "Who has a Pink toy?", options: ["Anna", "Jake", "Mia", "Liam"], answer: "Mia" },
          { q: "What color is the Ball?", options: ["Red", "Blue", "Pink", "Yellow"], answer: "Red" },
          { q: "Who owns a Small Car?", options: ["Jake", "Liam", "Noah", "Anna"], answer: "Jake" },
          { q: "Which toy is Yellow?", options: ["Blocks", "Puzzle", "Ball", "Doll"], answer: "Blocks" },
          { q: "Who has a Big toy?", options: ["Anna", "Jake", "Liam", "Mia"], answer: "Anna" },
          { q: "Which toy is Medium?", options: ["Ball", "Doll", "Car", "Blocks"], answer: "Doll" },
          { q: "Who has a Puzzle?", options: ["Jake", "Noah", "Liam", "Anna"], answer: "Liam" }
        ]
      },
      birthdays: {
        headers: ["Name", "Month", "Cake Flavor", "Age"],
        data: [
          ["Sophie", "January", "Chocolate", "6"],
          ["Mason", "March", "Vanilla", "7"],
          ["Ava", "May", "Strawberry", "5"],
          ["Logan", "July", "Chocolate", "8"],
          ["Chloe", "October", "Vanilla", "6"]
        ],
        questions: [
          { q: "Who has a birthday in May?", options: ["Sophie", "Mason", "Ava", "Logan"], answer: "Ava" },
          { q: "What is Chloe's cake flavor?", options: ["Chocolate", "Vanilla", "Strawberry", "Lemon"], answer: "Vanilla" },
          { q: "Who is 8 years old?", options: ["Sophie", "Mason", "Logan", "Chloe"], answer: "Logan" },
          { q: "Who has a Chocolate cake?", options: ["Logan", "Mason", "Ava", "Chloe"], answer: "Logan" },
          { q: "Who is 5 years old?", options: ["Sophie", "Ava", "Logan", "Mason"], answer: "Ava" },
          { q: "Who celebrates in October?", options: ["Sophie", "Chloe", "Logan", "Mason"], answer: "Chloe" },
          { q: "Who is the youngest?", options: ["Ava", "Logan", "Mason", "Chloe"], answer: "Ava" }
        ]
      },
      zoo: {
        headers: ["Visitor", "Animal Seen", "Color", "Day"],
        data: [
          ["Ella", "Elephant", "Gray", "Monday"],
          ["Sam", "Zebra", "Black & White", "Tuesday"],
          ["Nina", "Tiger", "Orange", "Wednesday"],
          ["Owen", "Giraffe", "Yellow", "Thursday"],
          ["Lily", "Monkey", "Brown", "Friday"]
        ],
        questions: [
          { q: "Who saw a Zebra?", options: ["Ella", "Sam", "Nina", "Lily"], answer: "Sam" },
          { q: "Which animal is Orange?", options: ["Elephant", "Tiger", "Monkey", "Giraffe"], answer: "Tiger" },
          { q: "What day did Ella visit?", options: ["Monday", "Tuesday", "Friday", "Thursday"], answer: "Monday" },
          { q: "Which animal is Yellow?", options: ["Elephant", "Zebra", "Giraffe", "Monkey"], answer: "Giraffe" },
          { q: "Who visited on Friday?", options: ["Ella", "Lily", "Nina", "Owen"], answer: "Lily" },
          { q: "Who saw the Tiger?", options: ["Sam", "Nina", "Lily", "Owen"], answer: "Nina" },
          { q: "What color is the Elephant?", options: ["Gray", "Orange", "Brown", "Yellow"], answer: "Gray" }
        ]
      }
    // Add other datasets like breakfast, classroom, etc.
  };

  const styles = {
    container: {
      fontFamily: "'Fredoka', sans-serif",
      padding: "2rem",
      maxWidth: "960px",
      margin: "auto",
      background: "#fff8f0",
      transition: "all 0.3s ease"
    },
    h1: {
      textAlign: "center",
      fontSize: "2.5rem",
      color: "#ff6b6b",
      textShadow: "2px 2px #ffe66d"
    },
    select: {
      padding: 12,
      margin: 10,
      borderRadius: 12,
      border: "none",
      fontSize: 16,
      fontWeight: "bold",
      backgroundColor: "#ffe66d",
      color: "#333"
    },
    btn: {
      padding: 12,
      margin: 10,
      borderRadius: 12,
      border: "none",
      fontSize: 16,
      fontWeight: "bold",
      backgroundColor: "#38bdf8",
      color: "white",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "2px 2px 4px rgba(0,0,0,0.2)"
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "1rem"
    },
    thtd: {
      border: "2px solid #ffe66d",
      padding: 10,
      textAlign: "center",
      backgroundColor: "#fffbe6"
    },
    th: {
      backgroundColor: "#ffd166",
      color: "#333"
    },
    question: {
      background: "#fff",
      padding: "1.2rem",
      borderRadius: "15px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      margin: "1rem 0"
    },
    correct: {
      backgroundColor: "#b9fbc0"
    },
    incorrect: {
      backgroundColor: "#ffadad"
    },
    radio: {
      transform: "scale(1.3)",
      marginRight: 10
    },
    score: {
      color: "#10b981",
      textShadow: "1px 1px #d1fae5"
    }
  };

  const handleDatasetLoad = () => {
    setUserAnswers({});
    setScore(null);
    setShowTable(false);
  };

  const handleAnswer = (qIndex, value) => {
    setUserAnswers(prev => ({ ...prev, [qIndex]: value }));
  };

  const handleSubmit = () => {
    const dataset = datasets[selectedDataset];
    let correct = 0;
    dataset.questions.forEach((q, idx) => {
      if (userAnswers[idx] === q.answer) {
        correct++;
      }
    });
    setScore(correct);
  };

  const renderTable = () => {
    const dataset = datasets[selectedDataset];
    return (
      <table style={styles.table}>
        <thead>
          <tr>
            {dataset.headers.map((h, i) => (
              <th key={i} style={{ ...styles.thtd, ...styles.th }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataset.data.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} style={styles.thtd}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderQuiz = () => {
    if (!selectedDataset) return null;
    const dataset = datasets[selectedDataset];

    return (
      <>
        {dataset.questions.map((q, idx) => (
          <div key={idx} style={styles.question}>
            <p><strong>Q{idx + 1}:</strong> {q.q}</p>
            {q.options.map((opt, i) => {
              let style = {};
              if (score !== null) {
                if (userAnswers[idx] === opt) {
                  style = opt === q.answer ? styles.correct : styles.incorrect;
                }
              }
              return (
                <label key={i} style={{ display: "block", ...style }}>
                  <input
                    type="radio"
                    name={`q${idx}`}
                    value={opt}
                    style={styles.radio}
                    checked={userAnswers[idx] === opt}
                    onChange={() => handleAnswer(idx, opt)}
                    disabled={score !== null}
                  />
                  {opt}
                </label>
              );
            })}
          </div>
        ))}
      </>
    );
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>❓ Dataset Quiz</h1>

      <div style={{ textAlign: "center" }}>
        <label htmlFor="datasetSelect">Choose a Dataset:</label>
        <select
          id="datasetSelect"
          style={styles.select}
          onChange={(e) => setSelectedDataset(e.target.value)}
          value={selectedDataset}
        >
          <option value="">-- Select --</option>
          {Object.keys(datasets).map(key => (
            <option key={key} value={key}>
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </option>
          ))}
        </select>

        <button style={styles.btn} onClick={handleDatasetLoad}>
          Load
        </button>

        {selectedDataset && (
          <button style={styles.btn} onClick={() => setShowTable(!showTable)}>
            {showTable ? "Hide Dataset" : "View Dataset"}
          </button>
        )}
      </div>

      {showTable && renderTable()}
      <div>{renderQuiz()}</div>

      {selectedDataset && Object.keys(userAnswers).length > 0 && (
        <div style={{ textAlign: "center" }}>
          <button style={styles.btn} onClick={handleSubmit}>
            Submit Answers
          </button>
          {score !== null && (
            <div style={styles.score}>
              <h2>Score: {score} / 7 🎉</h2>
            </div>
          )}
        </div>
      )}
    </div>
  );
}